'use strict';

module.exports = [
    function() {
        return function(input) {
            if(!Array.isArray(input)) {
                return '';
            }

            let names = input.map(presenter => {
                return presenter.name;
            });

            return names.join(', ');
        };
    }
];

